<template>
	<div class="newspaper blog" id="newspaper-content">
		<Teleport to="#header">
			<!-- <div class="navigation blog">
				<div>Writing</div>
				<div>News</div>
				<div>Sports</div>
				<div>Arts</div>
			</div> -->
			
		</Teleport>
		<div id="highlights" v-if="used_highlights">
			<div
				id="main-story"
				:style="`background-image: url(${getArticle(used_highlights.mainHighlight.slug).images[used_highlights.mainHighlight.imageIndex]})`"
				class="d-flex d-lg-block"
			>
				<div
					class="section-badge section-badge-absolute"
					:class="
						getArticle(
							used_highlights.mainHighlight.slug,
						).section.toLowerCase()
					"
				>
					{{ getArticle(used_highlights.mainHighlight.slug).section }}
				</div>
				<div class="details col-lg-4">
					<div>
						<DetailsComponent
							:article="
								getArticle(used_highlights.mainHighlight.slug)
							"
							excerpt
						/>
					</div>
				</div>
			</div>
			<!-- <div class="box" id="weather">This will be a weather plugin</div> -->
			<WeatherComponent></WeatherComponent>
			<!-- <div class="box side-panel d-none d-md-block" id="sports">This will be a sports plugin</div> -->
			<!-- <SportsComponent/> -->
			<!-- <div id="recent" class="d-none d-md-flex">
				<div>
					<div class="p-2"><h3>Recently published</h3></div>
					<div v-for="r in recent" class="animate-bg" :class="r.section.toLowerCase()">
						<p class="p-2">
							{{
								r.title.length > headlineCutoff
									? r.title.slice(0, headlineCutoff) + "..."
									: r.title
							}} 
							<br>- {{ r.author }}
						</p>
					</div>
				</div>
			</div> -->
			<div id="other-highlights" class="stories">
				<StoryComponent
					class="story"
					v-for="story in mainStories"
					:article="story"
				/>
			</div>
		</div>
		<hr />
		<h2>Recent Stories</h2>
		<div class="stories stories-4">
			<!-- The 4 grid -->
			<StoryComponent
				v-for="article in otherArticles.slice(0, 8)"
				class="col"
				:article="article"
			/>
		</div>
		<hr />
		<template v-for="section in used_highlights.highlightSections">
			<h2>{{ section.name }}</h2>
			<div class="stories stories-4">
				<StoryComponent
					v-for="article in TheLink
						.filter(
							(a) => a.section.toLowerCase() == section.section,
						)
						.filter((a) => !shownSlugs.includes(a.slug))
						.slice(0, section.count)"
					class="col"
					:article="article"
				/>
			</div>
			<hr />
		</template>
	</div>
</template>
<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { getThumbnailImage } from "../articles";
import SportsComponent from "../components/news/SportsComponent.vue";
import WeatherComponent from "../components/news/WeatherComponent.vue";
import TheLink from "@/data/articles.json"; // articles included with build. used as fallback
import highlights from "@/data/highlights.json"; // highlights included with build. used as fallback
import DetailsComponent from "../components/publications/DetailsComponent.vue";
import StoryComponent from "../components/publications/StoryComponent.vue";
import { useLogoStore } from "../stores/logostore";



const logostore = useLogoStore();
logostore.set_news();

onBeforeUnmount(() => {
	logostore.reset();
})

const articles_url = "/data/articles.json";
const highlights_url = "/data/highlights.json";

let _all_articles = [];
const all_articles = ref(_all_articles.concat(TheLink));

const async_articles = ref(null); // Articles fetched from the server
const used_articles = ref(all_articles); // Articles that will be displayed.

const async_highlights = ref(null); // Highlights fetched from the server
const used_highlights = ref(highlights); // Highlights that will be displayed

const headlineCutoff = ref(32);

const loaded = computed(() => {
	return used_articles.value && used_highlights.value;
});

async function getHighlights() {
	return await fetch(highlights_url)
		.then((o) => {
			if (o.ok) {
				return o.json();
			} else {
				return highlights;
			}
		})
		.then((c) => {
			used_highlights.value = c;
			return c;
			// loaded.value = true;
		});
}

async function getArticles() {
	return await fetch(articles_url)
		.then((o) => {
			if (o.ok) {
				return o.json();
			} else {
				return articles;
			}
		})
		.then((c) => {
			used_articles.value = c;
			return c;
			// loaded.value = true;
		});
}
onMounted(() => {
	getHighlights();
});

async function fetchData() {}

const mainStories = computed(() => {
	console.log(used_highlights.value.mainStories);

	let out = TheLink.filter((a) =>
		used_highlights.value.mainStories.map((s) => s.slug).includes(a.slug),
	);
	// return
	console.log(out);
	return out;
});

const shownSlugs = computed(() => {
	let out = [];
	// main story
	out.push(used_highlights.value.mainHighlight.slug);

	// three highlights
	out.push(...mainStories.value.map((s) => s.slug));

	// first 8 showcased
	out.push(...otherArticles.value.slice(0, 8).map((a) => a.slug));
	console.log(out);
	return out;
});

const otherArticles = computed(() => {
	return used_articles.value
		.filter((a) => a.slug !== used_highlights.value.mainHighlight.slug)
		.filter(
			(a) =>
				!used_highlights.value.mainStories
					.map((s) => s.slug)
					.includes(a.slug),
		);
});

function getArticle(slug) {
	return used_articles.value.filter((a) => a.slug == slug)[0];
}

const recent = computed(() => {
	return otherArticles.value
		.sort((b, a) => (a.date > b.date ? 1 : a.date < b.date ? -1 : 0))
		.slice(0, 5);
});
</script>
